<section class="w-full bg-white dark:bg-slate-800 px-15 pb-10">
    <div class="flex flex-col items-center justify-center mt-10">
        <div class="w-full flex justify-center items-center mb-10">
            <div class="w-full flex flex-row p-10 justify-between items-center">
                <div class="flex flex-col">
                    @if (view.site && view.site.profile && view.site.profile.heading) {
                            @switch (view.site.profile.heading.position) {
                                @case (1) {
                                    <app-heading_section-type01 [options]="{heading:' Popular Hotels',title:' Book a Hotel Within Your Budget  ',image:'', description:'',swooshAlign: {'margin':''} }" ></app-heading_section-type01>
                                    }
                                @case (2) {
                                    <app-heading_section-type01 [options]="{heading:' Popular Hotels',title:' Book a Hotel Within Your Budget  ',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                                }
                            }
                        }

                </div>
                <div class="flex flex-row">
                     <div class="group">
                        <div class="flex items-center justify-center mr-5 w-15 h-15 cursor-pointer bg-primary-100 group-hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full">
                            <mat-icon class="icon-size-6 text-primary-500 group-hover:text-primary-100 transition ease-out duration-500" [svgIcon]="'feather:arrow-left'"></mat-icon>
                        </div>
                    </div>
                    <div class="group">
                        <div class="flex items-center justify-center w-15 h-15 cursor-pointer bg-primary-100 group-hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full">
                            <mat-icon class="icon-size-6 text-primary-500 group-hover:text-primary-100 transition ease-out duration-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <fuse-card>
                <a href="#"
                    class="relative h-140 w-100 md:w-110 lg:w-140 flex flex-col justify-end overflow-hidden px-8 pb-8 pt-40 mx-auto hover:shadow-lg">
                    <img src="https://images.pexels.com/photos/1680249/pexels-photo-1680249.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                        alt="destination australia" class="absolute inset-0 h-full w-full object-cover" />
                    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                    <div class="flex justify-between items-center z-10">
                        <div>
                            <p class="text-primary-100 text-lg">
                                Price<span class="text-lg ml-2">$120.00 NIGHT</span>
                            </p>
                            <h3 class="text-primary-100 text-3xl font-primary tracking-wider">
                                Australia
                            </h3>
                        </div>
                        <div class="flex">
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                        </div>
                    </div>
                </a>
            </fuse-card>
            <fuse-card>
                <a href="#"
                    class="relative h-140 w-100 md:w-110 lg:w-140 flex flex-col justify-end overflow-hidden px-8 pb-8 pt-40 mx-auto hover:shadow-lg">
                    <img src="https://images.pexels.com/photos/3185493/pexels-photo-3185493.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                        alt="destination australia" class="absolute inset-0 h-full w-full object-cover" />
                    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                    <div class="flex justify-between items-center z-10">
                        <div>
                            <p class="text-primary-100 text-lg">
                                Price<span class="text-lg ml-2">$120.00 NIGHT</span>
                            </p>
                            <h3 class="text-primary-100 text-3xl font-primary tracking-wider">
                                Istanbul
                            </h3>
                        </div>
                        <div class="flex">
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                            <mat-icon class="text-accent-600" [svgIcon]="'mat_solid:star'"></mat-icon>
                        </div>
                    </div>
                </a>
            </fuse-card>
        </div>
    </div>
</section>